import React, { useEffect, useState, useRef } from "react";
import SubmitBackIcon from './../../../../images/purplebackicon.png'
import Select from 'react-select'
import N3rveLogo from './../../../../images/N3rveLogo.png'
import InstagramLogo from './../../../../images/instagramlogo.png'
import TwitterLogo from './../../../../images/twitterlogo.png'
import DiscordLogo from './../../../../images/discordlogo.png'
import { useNavigate } from "react-router-dom";
import { logtoWix } from "../../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from 'universal-cookie';
import { subtitles } from "@cloudinary/url-gen/qualifiers/source";

function SupportForm() {
    const [successfulRequest, setSuccessfulRequest] = useState(false)
    const [email, setEmail] = useState("")
    const [typeOfRequest, setTypeOfRequest] = useState("")
    const [nervePlan, setNervePlan] = useState("")
    const [subject, setSubject] = useState("")
    const [desc, setDesc] = useState("")
    const [files, setFiles] = useState([])
    const [dragActive, setDragActive] = useState(false)
    const inputRef = useRef(null)
    const navigate = useNavigate()
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const cookies = new Cookies(null, { path: '/' });

    const handleResize = () => {
        console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    const toroptions = [{ value: 'Account', label: 'Account' },
    { value: 'App', label: 'App' },
    { value: 'Distribution', label: 'Distribution' },
    { value: 'Exclusive', label: 'Exclusive' },
    { value: 'Payment', label: 'Payment' },
    { value: 'Promotion', label: 'Promotion' },
    { value: 'Referrals', label: 'Referrals' },
    { value: 'Socials', label: 'Socials' },
    { value: 'Split Payment', label: 'Split Payment' },
    { value: 'Terms of Use', label: 'Terms of Use' },
    { value: 'Video', label: 'Video' },
    { value: 'Mastering', label: 'Mastering' }]

    const npooptions = [{ value: 'N3RVOUS (Free)', label: 'N3RVOUS (Free)' },
    { value: 'N3RVE', label: 'N3RVE' },
    { value: 'N3RVE Premier', label: 'N3RVE Premier' },
    { value: 'N3XUS', label: 'N3XUS' }]

    const changetorHandler = value => {
        setTypeOfRequest(value)
    }

    const changenpoHandler = value => {
        setNervePlan(value)
    }

    const colourStyles = {
        container: base => ({
            ...base,
            flex: 1
        }),
        control: styles => ({
            ...styles, borderColor: '#636468',
            backgroundColor: 'rgba(0,0,0,16%)',
            maxWidth: '35.18em',
            width: '100%',
            height: '3em',
            borderRadius: '8px',
            color: 'rgba(255, 255, 255, 1)',
            marginTop: '1.2em'
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: '#18191F',
                color: 'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop: '-0.3em',
                marginBottom: '-0.3em'
            };
        },
        input: (styles) => ({
            ...styles,
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%',
            color: 'rgba(255, 255, 255, 1)'
        }),
        singleValue: (styles) => ({
            ...styles,
            color: 'rgba(255, 255, 255, 1)',
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%'
        })
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    }

    const onButtonClick = () => {
        inputRef.current.click();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            var filelist = []
            for (var i = 0; i < e.dataTransfer.files.length; i++) {
                filelist.push(e.dataTransfer.files[i])

            }
            setFiles(filelist)
        }
    };

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const filelist = []
            for (var i = 0; i < e.target.files.length; i++) {

                filelist.push(e.target.files[i])
            }

            setFiles(filelist)
        }
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
    }, [])

    useEffect(() => {

    }, [desc])



    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const LogForm = (email, typeofrequest, nerveplan, subject, description, files) => {
        if (cookies.get('token') !== undefined) {
            if (decodeToken(cookies.get('token')) !== null) {
                logtoWix(decodeToken(cookies.get('token')).email, "form submit", "Help Page", { "desc": "User filled help form", "email": email, "typeofrequest": typeofrequest, "nerveplan": nerveplan, "subject": subject, "description": description, "files": files })
            } else {
                logtoWix("anonymous user", "form submit", "Help Page", { "desc": "User filled help form", "email": email, "typeofrequest": typeofrequest, "nerveplan": nerveplan, "subject": subject, "description": description, "files": files })
            }
        } else {
            logtoWix("anonymous user", "form submit", "Help Page", { "desc": "User filled help form", "email": email, "typeofrequest": typeofrequest, "nerveplan": nerveplan, "subject": subject, "description": description, "files": files })
        }
    }

    return (
        <div>
            {
                dimensions.width < 820 &&
                <div style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/p9kcqw2gyze2ewrfdzwf")`, backgroundPositionX: '-0.5em', backgroundSize: 'cover', position: 'relative', minHeight: '100vh', height: 'auto' }}>
                    {
                        !successfulRequest &&
                        <div>
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingBottom: '15.5em',
                                paddingTop: '7.56em'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    width: '70%',
                                    paddingTop: '2.5em',

                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        marginLeft: '-2em'
                                    }} onClick={() => { navigate("/help"); setEmail(""); setTypeOfRequest(""); setNervePlan(""); setSubject(""); setDesc(""); setFiles([]) }}>
                                        <img src={SubmitBackIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '0.25em', cursor: 'pointer' }} />
                                        <div className="backTxt" style={{ color: '#C7A5FF', fontWeight: '400' }}>Back</div>


                                    </div>

                                    <div className="SubmitHeader">
                                        Submit a request
                                    </div>

                                    <div className="SubmitInputHeader">
                                        Your Email
                                    </div>

                                    <input
                                        value={email}
                                        onChange={e => { setEmail(e.target.value); }}
                                        className='InputFieldbk'
                                        type='text'
                                        placeholder="Enter Email"
                                        style={{ marginBottom: '0em', width: '100%' }}
                                    />

                                    <div className="SubmitInputHeader">
                                        Type of Request
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '105%', maxWidth: '35.18em' }}>
                                        <Select options={toroptions} value={typeOfRequest} onChange={changetorHandler}
                                            placeholder="What do you need support with?"
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={
                                                colourStyles
                                            }
                                        />
                                    </div>

                                    <div className="SubmitInputHeader">
                                        N3RVE Plan
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '105%', maxWidth: '35.18em' }}>
                                        <Select options={npooptions} value={nervePlan} onChange={changenpoHandler}
                                            placeholder="What is your N3RVE plan type?"
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={
                                                colourStyles
                                            }
                                        />
                                    </div>


                                    <div className="SubmitInputHeader">
                                        Subject
                                    </div>

                                    <input
                                        value={subject}
                                        onChange={e => { setSubject(e.target.value); }}
                                        className='InputFieldbk'
                                        type='text'
                                        placeholder=""
                                        style={{ marginBottom: '0em', width: '100%' }}
                                    />


                                    <div className="SubmitInputHeader">
                                        Description
                                    </div>

                                    <div className="SubmitInputHeaderDesc" style={{ maxWidth: '34.187em', paddingBottom: '0.5em' }}>
                                        To help us address your issue swiftly, kindly include all pertinent details in your request, such as links to artist pages or screenshots of any error messages you're encountering. Our support staff will be in touch with you promptly.
                                    </div>

                                    <textarea rows="4" cols="50" className='InputFieldbktextarea' onChange={e => { setDesc(e.target.value); }} style={{ maxWidth: '34.187em', width: '100%' }} value={desc} />



                                    <div className="SubmitInputHeader">
                                        Files
                                    </div>

                                    {
                                        files.length === 0 &&
                                        <form id="form-file-upload3" style={{ cursor: 'pointer', maxWidth: '34.187em', width: '100%' }} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                                            <input ref={inputRef} type="file" id="input-file-upload" multiple={true} onChange={handleChange} />
                                            <label id="label-file-upload" htmlFor="input-file-upload" className={dragActive ? "drag-active" : ""}>


                                                <span className="DragDropText">
                                                    <button className="upload-button" onClick={onButtonClick} style={{ color: '#C7A5FF', textDecoration: 'underline' }}>
                                                        Add files
                                                    </button>
                                                    or drag files here
                                                </span>

                                            </label>

                                            {dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
                                        </form>
                                    }

                                    {
                                        files.length !== 0 &&
                                        <div className="UploadContainer" style={{ marginBottom: '0em', maxWidth: '34.187em', width: '100%' }}>
                                            {
                                                files.map((file) => {

                                                    return (
                                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.75em', width: '85%', justifyContent: 'space-between' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div className="FileName">
                                                                    {file.name}
                                                                </div>

                                                            </div>

                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', maxWidth: '34.187em', width: '100%' }}>
                                        <div className="SubmitRequestBtn" onClick={() => { LogForm(email, typeOfRequest, nervePlan, subject, desc, files); setSuccessfulRequest(true); topFunction() }} style={{ alignSelf: 'center', marginLeft: '0em', marginRight: '0em' }}>
                                            SUBMIT
                                            <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px', left: '0em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        successfulRequest &&
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '20em' }}>
                            <div className="successHeader">
                                Thank you for reaching out to N3RVE Support!
                            </div>

                            <div className="successInfo">
                                Request Submitted Successfully<br />
                                Your request has been received and is currently being reviewed by our support team. We are committed to assisting you as quickly as possible.
                            </div>

                            <div className="SubmitRequestBtn" style={{ alignSelf: 'center' }} onClick={() => { setSuccessfulRequest(false); navigate("/help") }}>
                                Back to Main
                                <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px', left: '0em' }} />
                            </div>

                        </div>
                    }



                </div>
            }

            {
                dimensions.width >= 820 &&
                <div style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/p9kcqw2gyze2ewrfdzwf")`, backgroundPositionX: '-0.5em', backgroundSize: 'cover', position: 'relative', minHeight: '100vh', height: 'auto' }}>
                    {
                        !successfulRequest &&
                        <div>
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingBottom: '15.5em',
                                paddingTop: '7.56em'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    width: '40%',
                                    paddingTop: '2.5em',

                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        marginLeft: '-2em'
                                    }} onClick={() => { navigate("/help"); setEmail(""); setTypeOfRequest(""); setNervePlan(""); setSubject(""); setDesc(""); setFiles([]) }}>
                                        <img src={SubmitBackIcon} style={{ width: '1.5em', height: '1.5em', marginRight: '0.25em', cursor: 'pointer' }} />
                                        <div className="backTxt" style={{ color: '#C7A5FF', fontWeight: '400' }}>Back</div>


                                    </div>

                                    <div className="SubmitHeader">
                                        Submit a request
                                    </div>

                                    <div className="SubmitInputHeader">
                                        Your Email
                                    </div>

                                    <input
                                        value={email}
                                        onChange={e => { setEmail(e.target.value); }}
                                        className='InputFieldbk'
                                        type='text'
                                        placeholder="Enter Email"
                                        style={{ marginBottom: '0em' }}
                                    />

                                    <div className="SubmitInputHeader">
                                        Type of Request
                                    </div>

                                    <Select options={toroptions} value={typeOfRequest} onChange={changetorHandler}
                                        placeholder="What do you need support with?"
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        styles={
                                            colourStyles
                                        }
                                    />

                                    <div className="SubmitInputHeader">
                                        N3RVE Plan
                                    </div>

                                    <Select options={npooptions} value={nervePlan} onChange={changenpoHandler}
                                        placeholder="What is your N3RVE plan type?"
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        styles={
                                            colourStyles
                                        }
                                    />



                                    <div className="SubmitInputHeader">
                                        Subject
                                    </div>

                                    <input
                                        value={subject}
                                        onChange={e => { setSubject(e.target.value); }}
                                        className='InputFieldbk'
                                        type='text'
                                        placeholder=""
                                        style={{ marginBottom: '0em' }}
                                    />


                                    <div className="SubmitInputHeader">
                                        Description
                                    </div>

                                    <div className="SubmitInputHeaderDesc" style={{ maxWidth: '34.187em', paddingBottom: '0.5em' }}>
                                        To help us address your issue swiftly, kindly include all pertinent details in your request, such as links to artist pages or screenshots of any error messages you're encountering. Our support staff will be in touch with you promptly.
                                    </div>

                                    <textarea rows="4" cols="50" className='InputFieldbktextarea' onChange={e => { setDesc(e.target.value); }} style={{ width: '34.187em' }} value={desc} />


                                    <div className="SubmitInputHeader">
                                        Files
                                    </div>

                                    {
                                        files.length === 0 &&
                                        <form id="form-file-upload3" style={{ cursor: 'pointer', width: '34.187em' }} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                                            <input ref={inputRef} type="file" id="input-file-upload" multiple={true} onChange={handleChange} />
                                            <label id="label-file-upload" htmlFor="input-file-upload" className={dragActive ? "drag-active" : ""}>


                                                <span className="DragDropText">
                                                    <button className="upload-button" onClick={onButtonClick} style={{ color: '#C7A5FF', textDecoration: 'underline' }}>
                                                        Add files
                                                    </button>
                                                    or drag files here
                                                </span>

                                            </label>

                                            {dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
                                        </form>
                                    }

                                    {
                                        files.length !== 0 &&
                                        <div className="UploadContainer" style={{ width: '90%', marginBottom: '0em', width: '34.187em' }}>
                                            {
                                                files.map((file) => {

                                                    return (
                                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.75em', width: '85%', justifyContent: 'space-between' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div className="FileName">
                                                                    {file.name}
                                                                </div>

                                                            </div>

                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '34.187em' }}>
                                        <div className="SubmitRequestBtn" onClick={() => { LogForm(email, typeOfRequest, nervePlan, subject, desc, files); setSuccessfulRequest(true); topFunction() }} style={{ alignSelf: 'center', marginLeft: '0em', marginRight: '0em' }}>
                                            SUBMIT
                                            <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px', left: '0em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        successfulRequest &&
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '20em' }}>
                            <div className="successHeader">
                                Thank you for reaching out to N3RVE Support!
                            </div>

                            <div className="successInfo">
                                Request Submitted Successfully<br />
                                Your request has been received and is currently being reviewed by our support team. We are committed to assisting you as quickly as possible.
                            </div>

                            <div className="SubmitRequestBtn" style={{ alignSelf: 'center' }} onClick={() => { setSuccessfulRequest(false); navigate("/help") }}>
                                Back to Main
                                <div className="PostLoginBtnOverlay" style={{ borderRadius: '999px', left: '0em' }} />
                            </div>

                        </div>
                    }



                </div>
            }
        </div>
    )
}

export default SupportForm;